var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M23.32 20.952c1.449-1.974 2.37-4.475 2.37-7.107C25.69 7.265 20.425 2 13.845 2A11.796 11.796 0 0 0 2 13.845c0 6.58 5.264 11.845 11.845 11.845 2.632 0 5.133-.921 7.107-2.37l6.185 6.186c.659.659 1.711.659 2.37 0a1.668 1.668 0 0 0 0-2.369l-6.186-6.185zM4.633 13.845a9.156 9.156 0 0 1 9.213-9.213 9.156 9.156 0 0 1 9.213 9.213 9.156 9.156 0 0 1-9.213 9.213 9.156 9.156 0 0 1-9.213-9.213z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#8998AA",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.958ad7f8922f4382ac595d2674181026.svg";
export { ForwardRef as ReactComponent };